import { components } from "@certn/legacy-api/generated-schemas/people";

import { ValidationRuleType } from "./types";

export function requireEducationRule(
  rule: components["schemas"]["RequireEducationsRule"]
): ValidationRuleType {
  return {
    rule,
    isValid: (
      educationQualifications: components["schemas"]["EducationCheckField"]["value"]
    ) => {
      if (rule.highest) {
        return educationQualifications.some(
          ({ highest_level }) => highest_level === true
        );
      }
      return educationQualifications.length >= rule.min;
    },
  };
}
